export const SEARCH_UNAVAILABLE_MESSAGE = 'Поиск временно недоступен. Попробуйте ещё раз позже.'

export function searchUnavailableMessage(error) {
	return error?.response?.status === 503 && error?.response?.data?.code === 'SEARCH_UNAVAILABLE'
		? SEARCH_UNAVAILABLE_MESSAGE
		: null
}
